import format from "date-fns/format";

const columns = [
  { Header: "ID", accessor: "_id" },
  { Header: "Number", accessor: "number" },
  { Header: "Name", accessor: "name" },
  { Header: "Customer", accessor: "customer" },
  { Header: "Contract Type", accessor: "contractType" },
  {
    Header: "Entered Date",
    accessor: "entered_date",
    Cell: ({ value }) =>
      value ? format(new Date(value), "MM/dd/yyyy kk:mm") : "--"
  },
  {
    Header: "Start Date",
    accessor: "start_date",
    Cell: ({ value }) =>
      value ? format(new Date(value), "MM/dd/yyyy kk:mm") : "--"
  },
  {
    Header: "End Date",
    accessor: "end_date",
    Cell: ({ value }) =>
      value ? format(new Date(value), "MM/dd/yyyy kk:mm") : "--"
  },
  { Header: "Salesperson", accessor: "salesperson" },
  { Header: "Annual Amount", accessor: "annual_amt" },
  { Header: "Monthly Amount", accessor: "monthly_amt" },
  { Header: "Billing Rate", accessor: "billing_rate" },
  { Header: "Invoice Format", accessor: "invoiceFormat" },
  { Header: "Invoice Frequency", accessor: "invoiceFrequency" },
  { Header: "Day to Send Invoice", accessor: "day_to_send_invoice" },
  { Header: "Invoice Email", accessor: "invoice_email" },
  { Header: "Report", accessor: "report" },
  { Header: "Report Format", accessor: "reportFormat" },
  { Header: "Day to Send Report", accessor: "day_to_send_report" },
  { Header: "Report Email", accessor: "report_email" },
  {
    Header: "Created By",
    accessor: "created_by"
  },
  { Header: "Modified By", accessor: "modified_by" },
  {
    Header: "Created On",
    accessor: "created_on",
    Cell: ({ value }) =>
      value ? format(new Date(value), "MM/dd/yyyy kk:mm") : "--"
  },
  {
    Header: "Modified On",
    accessor: "modified_on",
    Cell: ({ value }) =>
      value ? format(new Date(value), "MM/dd/yyyy kk:mm") : "--"
  }
];

export default columns;
